import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import { checkVirtualNumber } from '@/shared/utils/validator';
import { Validator } from '@hb/finance-ui';
import { trimValue } from '@/shared/utils/trim';
import UserPersonalInfoApi from '@/api/userPersonalInfo';
import { formatPhone344 } from '@/components/supplement-info-fields/utils';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'ContactPhone' })
export default class ContactPhone extends Vue implements InfoComplementField {
  @Prop()
  private value!: string;

  @Prop()
  private commodityId!: string;

  private contactPhone = '';

  private errorMsg = '';

  public async onValidator(): Promise<boolean> {
    const val = this.contactPhone;
    if (!(val && Validator.isPhoneNo(val))) {
      this.errorMsg = '请填写正确的手机号';
      return false;
    }
    if (!(val && checkVirtualNumber(val))) {
      this.errorMsg = '该号段不支持，请输入正确的号码';
      return false;
    }

    if (!(val && await this.checkWithUserPhone(val))) {
      this.errorMsg = '联系人手机号码不能和注册号码一致';
      return false;
    }

    if (!(val && await this.checkWithBankCardPhone(val))) {
      this.errorMsg = '请勿填写本人银行卡预留手机号';
      return false;
    }

    if (!(val && await this.checkUnavailablePhone(val, this.commodityId))) {
      this.errorMsg = '请修改为有效联系电话';
      return false;
    }

    return true;
  }

  /** 联系人手机号不能和注册号码一致 */
  private async checkWithUserPhone(phone: string): Promise<boolean> {
    const trimPhoneNum = trimValue(phone);
    const { checkPhoneNumRes } = await UserPersonalInfoApi
      .checkUserContact({ contactPhone: trimPhoneNum }) || {};
    return !checkPhoneNumRes;
  }

  /** 联系人手机号不能和银行卡预留手机一致 */
  private async checkWithBankCardPhone(phone: string): Promise<boolean> {
    const trimPhoneNum = trimValue(phone);
    const { isSamePhoneNumRes } = await UserPersonalInfoApi
      .checkUserContact({ contactPhone: trimPhoneNum }) || {};
    return isSamePhoneNumRes !== true;
  }

  /** 联系人手机是否可用 */
  private async checkUnavailablePhone(phone: string, commodityId: string): Promise<boolean> {
    const trimPhoneNum = trimValue(phone);
    const { isUnavailableRes } = await UserPersonalInfoApi
      .checkUserContact({ contactPhone: trimPhoneNum, commodityId }) || {};
    return isUnavailableRes !== true;
  }

  private created() {
    if (this.value) {
      this.contactPhone = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    if (val !== this.contactPhone) {
      this.contactPhone = val;
    }
  }

  private onChangeTelNumber(val: string) {
    this.errorMsg = '';
    const formattedPhone = formatPhone344(val);
    this.contactPhone = formattedPhone;
    this.$emit('change', this.contactPhone);
  }

  private render() {
    return (
      <div class={style.ContactPhone}>
        <Field
          v-model={this.contactPhone}
          class="border"
          sub={true}
          type="tel"
          maxLength={13}
          label="手机号"
          placeholder="填写联系人的手机号"
          onChange={this.onChangeTelNumber.bind(this)}
          error={this.errorMsg}
        />
      </div>
    );
  }
}
